"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "varese": {
    "225fe961": [{
      "hkey": "0388c4df",
      "slug": "fogliaro",
      "name": "Fogliaro",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;